<section class="statistics-section" #statisticsSection>
  <div class="atw-container">

    <div class="statistics-card-wrapper">

      <div class="statistics-header">
        <div class="section-title statistics-title">
          <span>
            <b>{{ 'atw.statistics.sectionNumber' | transloco }}</b>
          </span>

          <div>
            <h2>{{ 'atw.statistics.title' | transloco }}</h2>
            <p>{{ 'atw.statistics.subtitle' | transloco }}</p>
          </div>
        </div>

        <div class="statistics-label">

          {{ 'atw.statistics.liveLabel' | transloco }}
        </div>
      </div>

      <div class="statistics-loading" *ngIf="isLoading">
        {{ 'atw.statistics.loading' | transloco }}
      </div>

      <div class="statistics-error" *ngIf="errorMessage && !isLoading">
        {{ errorMessage }}
      </div>

      <div class="statistics-grid" *ngIf="!isLoading">

        <div
          class="stats-card"
          *ngFor="let card of statsCards"
        >
          <div class="stats-top">
            <div class="stats-icon">
              <img
                class="img-l"
                [src]="card.iconImg"
                [alt]="card.title | transloco"
              />
            </div>

            <span class="stats-tag">{{ card.tag | transloco }}</span>
          </div>

          <div class="stats-number">
            {{ displayTotals[card.key] | number }}
          </div>

          <div class="stats-content">
            <strong>{{ card.title | transloco }}</strong>
            <p>{{ card.text | transloco }}</p>
          </div>

          <div class="stats-line">
            <span></span>
          </div>
        </div>

      </div>

    </div>

  </div>
</section>